<template>
  <div>
    <div v-if="current.status === 1">
      <template v-if="$has('FWS-SFKGL-FKD-FK')">
        <!-- 支付宝-码牌 -->
        <el-button
          v-if="current.payMode === 'ALIPAY' && current.payWay === 32"
          class="table-button table-button-success"
          icon="el-icon-success"
          @click="handlePayment('qrcodePay', '确认付款', current)"
          v-track
          trackCode="paymentList-8"
        >确认付款</el-button>
        <!-- 现金 -->
        <el-button
          v-else-if="current.payMode === 'CASH_PAY'"
          class="table-button table-button-success"
          icon="el-icon-success"
          @click="handlePayment('confirmPay', '确认付款', current)"
          v-track
          trackCode="paymentList-8"
        >确认付款</el-button>
        <!-- ACCOUNT_PAY 账户付款 -->
        <template v-else-if="current.payMode !== 'ACCOUNT_PAY'">
          <!-- 线上，对公账户，只能走线下付款 -->
          <el-button
            class="table-button table-button-success"
            icon="el-icon-success"
            v-if="showPaymentBtn('online')"
            @click="handlePayment('online', paymentStr, current)"
            v-track
            trackCode="paymentList-9"
          >{{ getButtonStr(current.type, "online") }}</el-button>
          <!-- 线下 -->
          <el-button
            class="table-button table-button-success"
            icon="el-icon-success"
            @click="handlePayment('offline', paymentStr, current)"
            v-if="showPaymentBtn('offline')"
            v-track
            trackCode="paymentList-10"
          >{{ getButtonStr(current.type, "offline") }}</el-button>
        </template>
        <template v-else>
          <el-button
            class="table-button table-button-success"
            icon="el-icon-success"
            @click="handlePayment('offline', paymentStr, current)"
            v-track
            trackCode="paymentList-10"
          >{{ getButtonStr(current.type, "default") }}</el-button>
        </template>
      </template>
      <!-- 采购付款类型 && 待付款 才有取消操作 -->
      <el-button
        class="table-button table-button-danger"
        icon="el-icon-error"
        @click="handleCancel(current)"
        v-if="$has('FWS-SFKGL-FKD-QX')"
        style="width: 88px;"
        v-track
        trackCode="paymentList-11"
      >取消</el-button>
    </div>
    <!-- 合并付款/再次付款 相同客户、账户 -->
    <payment-operate
      :visible.sync="isPaymentOperateShow"
      :payment-no="paymentNo"
      :payment-obj="paymentObj"
      :is-batch="isBatchPay"
      :title="paymentTitle"
      :type="paymentType"
      @success="handleOperateStateResults()"
    />

    <!-- 码牌确认付款 -->
    <qrcode-operate
      :visible.sync="isQrcodeShow"
      :payment-obj="paymentObj"
      :title="paymentTitle"
      @success="handleOperateStateResults()"
    />
    <payment-tip-dialog :visible.sync="isPaymentTipShow" :dataInfo="checkResultInfo" />
  </div>
</template>

<script>
import paymentOperate from './payment-operate'; // 再次付款
import { cancelPayment, payCommitCheck } from '@/api/receivables';
import qrcodeOperate from './qrcode-operate'; // 码牌确认付款
import paymentTipDialog from './payment-tip-dialog'; // 付款提示弹窗

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: [String, Number],
      default: '1',
    },
  },
  components: { paymentOperate, qrcodeOperate, paymentTipDialog },
  data() {
    return {
      paymentType: '', // 付款类型-综合/线下/线上
      isBatchPay: false, // 是否批量付款
      paymentObj: {}, // 付款单对象
      isPaymentOperateShow: false, // 发起付款再次付款
      paymentTitle: '', // 标题
      paymentNo: '',
      isQrcodeShow: false, // 码牌确认付款
      checkResultInfo: {}, // 校验结果
      isPaymentTipShow: false, // 付款提示弹窗
      isCheckResult: null, // 校验结果
    };
  },
  computed: {
    paymentStr() {
      return ['1', 1].includes(this.type) ? '发起退款' : '发起付款';
    },
    againPaymentStr() {
      return ['1', 1].includes(this.type) ? '再次退款' : '再次付款';
    },
  },
  methods: {
    showPaymentBtn(type) {
      const { payRemarks } = this.current;
      return !payRemarks || payRemarks === type;
    },
    handleOperateStateResults() {
      this.$emit('success');
    },
    /**
     * @param {*} paymentType 付款单类型，1 退货付款单，2采购付款单
     * @param {*} type 线上线下类型
     */
    getButtonStr(paymentType, type) {
      const payType = Number(paymentType);
      const typeList = {
        1: {
          online: '线上退款',
          offline: '线下退款',
          default: '发起退款',
        },
        2: {
          online: '线上付款',
          offline: '线下付款',
          default: '发起付款',
        },
        4: {
          online: '线上付款',
          offline: '线下付款',
          default: '发起付款',
        },
        default: {
          online: '线上付款',
          offline: '线下付款',
          default: '发起付款',
        },
      };
      return typeList[payType] ? typeList[payType][type] : typeList[payType].default;
    },
    async _payCommitCheck() {
      try {
        const { paymentNo } = this.current;
        const res = await payCommitCheck({ paymentNoList: [paymentNo] });
        const { data } = res || {};
        this.checkResultInfo = data || {};
        this.isCheckResult = data.checkResult;
      } catch (error) {
        console.log(error);
        this.isCheckResult = null;
      }
    },
    // 再次付款弹窗/发起付款弹窗
    async handlePayment(type, title, row) {
      await this._payCommitCheck();
      if (this.isCheckResult) {
        this.isBatchPay = false;
        this.paymentNo = row?.paymentNo || '';
        this.paymentTitle = title;
        this.paymentObj = row || {};
        // 付款方式：BANK_CARD_PAY - 银行卡，ALIPAY - 支付宝，ACCOUNT_PAY - 余额
        // 付款渠道：1-机构代付、 2-微信企业付款、 3-支付宝企业付款、 4-银企直连、 5-人工转账、 0-原路退款
        this.paymentType = type;
        if (type === 'qrcodePay') {
          this.isQrcodeShow = true;
        } else {
          this.isPaymentOperateShow = true;
        }
      }
      if (!this.isCheckResult && this.isCheckResult !== null) {
        this.isPaymentTipShow = true;
      }
    },
    handleCancel(row) {
      this.$confirm('是否取消该付款单，取消后无法撤销', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        await cancelPayment({ paymentNo: row.paymentNo || '' });
        this.$message.success('取消成功！');
        this.$emit('success');
      });
    },
  },
};
</script>
